/**
 * TLDs that Snap can register domains on.
 *
 * We need to support anything in certifier: https://certifier.sc-corp.net/request/dns?select=create
 *
 * We ran into size issues importing all of possible TLDs from
 * https://github.com/thom4parisot/tld.js or https://www.npmjs.com/package/parse-domain both of
 * which use https://publicsuffix.org/list/public_suffix_list.dat which is HUGE. For practical
 * reasons we only need to account for the domains that Snap is likely to purchase, which would in
 * all likelyhood be a subset of where Google is.
 */
const topLevelDomains = [
  // Origin top level domains.
  // https://en.wikipedia.org/wiki/List_of_Internet_top-level_domains#Original_top-level_domains.
  'com',
  'net',
  'org',
  'int',
  'mil',
  'edu',
  'gov',

  // Domains from Certifier
  // https://certifier.sc-corp.net/request/dns?select=create
  'io',
  'as',
  'co',
  'ly',
  'ht',
  'ar',
  'co.uk',

  // Domains from Google
  'app', // For Cloud Run's *.run.app
] as const;

/** Returns the top level domain from a hostname. */
export const getTopLevelDomain = (hostname: string): string => {
  const topLevelDomain = topLevelDomains.find(tld => hostname.endsWith(tld));
  if (!topLevelDomain) return hostname; // Give up and return hostname.

  const noTld = hostname.substring(0, hostname.length - topLevelDomain.length - 1);
  const lastPeriod = noTld.lastIndexOf('.');
  return lastPeriod > 0 ? `${hostname.substring(lastPeriod + 1)}` : hostname;
};
